<template>
    <nav class="topbar">
        <!-- Modal -->
        <Modal :config="regnskabModalConfig" @accept="changeRegnskab()">
            <template slot="header">
                Skift regnskab
            </template>
            <template slot="content">
                <div class="form grid-x">
                    <div v-for="regnskab in regnskabList()" :key="regnskab.id" @click="setActiveRegnskabId(regnskab.id)" :class="{'selected': regnskab.id === activeRegnskabId}" class="form-item auto cell">
                        <div class="flex-center">
                            <p>{{regnskab.beskrivelse}}</p>
                        </div>
                        <div v-if="regnskab.id === activeRegnskabId" class="checkmark-checked">
                            <icon class="small-svg fill-white" name="aktiveret"></icon>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>

        <div class="flex-container">
            <div class="flex-item">
                <icon class="small-medium-svg fill-white margin-right-10" name="administration"></icon>
                <h5>
                    <router-link :to="{name: 'dashboard'}">
                        <b>NIRAS</b>
                        <span class="font-lighter">UTILITY/VALUE</span>
                    </router-link>
                    <span class="seperator-top"></span>
                    <div @click="changeRegnskabModal()" class="topbar-select">
                        <span><span class="font-lighter" style="text-decoration: underline;">{{getSelectedRegnskabName()}}</span></span>
                    </div>
                </h5>
            </div>
            <div @click="toggleMenu()" class="flex-item-end">
                <div class="image">
                    <icon class="user-svg" name="user"></icon>
                </div>
                <div class="user-info">
                    <span class="user">
                        {{userInfo.name}}
                    </span>
                </div>
            </div>

            <div v-show="showMenu" class="dropdown-menu">
                <ul>
                    <li>
                        <a @click="signOut()">
                            <div class="image-container">
                                <icon class="log-out small-svg" name="log-out"></icon>
                            </div>
                            Log ud
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'

var VueCookie = require('vue-cookie')

export default {
    name: 'topbar',
    components: {
        Modal
    },
    data () {
        return {
            // menu
            showMenu: false,
            // modal
            regnskabModalConfig: null,
            activeRegnskabId: null
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            regnskabList: 'getRegnskabList',
            selectedRegnskab: 'getSelectedRegnskab'
        })
    },
    methods: {
        changeRegnskabModal () {
            this.regnskabModalConfig.open()
        },
        changeRegnskab () {
            VueCookie.set('selectedRegnskab', this.activeRegnskabId, {expires: '1Y'})
            this.$router.push({
                name: 'dashboard'
            })
            location.reload()
        },
        toggleMenu () {
            this.showMenu = !this.showMenu
        },
        signOut () {
            let link = this.$router.resolve({ name: 'login' })
            window.location = link.href
        },
        getSelectedRegnskabName () {
            if (this.selectedRegnskab) {
                if (this.selectedRegnskab.beskrivelse) {
                    return this.selectedRegnskab.beskrivelse
                }
            }
            return ''
        },
        setActiveRegnskabId (id) {
            this.activeRegnskabId = id
        }
    },
    created () {
        this.regnskabModalConfig = new ModalConfig({
            reject: 'Annuller',
            accept: 'Gem'
        })
        this.activeRegnskabId = VueCookie.get('selectedRegnskab')
    }
}
</script>

<style lang="scss" scoped>

.flex-container {
    display: flex;
    flex-direction: row;
    position: relative;

    .margin-right-10 {
        margin-right: 10px;
    }

    .flex-item {
        width: 100%;
        display: flex;
        align-items: center;

        h5 {
            display: flex;
            margin-top: 0px;
        }
        
        a {
            color: #fff;
        }
    }

    .flex-item-end {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        flex: 0 0 auto;

        .image {
            display: flex;
            align-items: center;

            svg {
                width: 35px;
                height: 35px;
                fill: #fff;
                margin-right: 4px;
            }
        }

        .user-info {
            display: flex;
            align-items: center;
            margin-left: 10px;

            .user {
                font-weight: 700;
                font-size: 1rem;
            }
        }
    }

    .dropdown-menu {
        position: absolute;
        right: -20px;
        top: 50px;
        width: auto;
        background-color: #fff;
        z-index: 99999999999;
        width: 180px !important;
        box-shadow: 0 2px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.07), 0 1px 4px 0 rgba(0,0,0,.1);

        a {
            display: block;
            padding: 15px 35px 15px 25px;
            color: #424242;
            background-color: #fff;
            transition: all .3s ease;

            &:hover {
                background-color: #eee;
            }

            .image-container {
                border-radius: 50%;
                padding: 6px;
                height: 30px;
                text-align: center;
                width: 30px;
                display: inline-block;
                position: relative;
                vertical-align: middle;
                margin-right: 5px;
                background-color: #fff;

                svg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    padding: 7px;
                }
            }
        }
    }
}

.form {
    margin-top: 10px;
    margin-bottom: 10px;

    .form-item {
        border-radius: 3px;
        height: 185px;
        position: relative;
        margin-left: 10px;
        margin-right: 10px;
        border: 2px solid transparent;
        box-shadow: 0 5px 10px 4px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);
        transform: scale(.95);
        cursor: pointer;
        transition: transform .3s ease;

        &:hover, &:active, &:focus {
            transform: scale(1) !important;
            box-shadow: 5px 20px 30px rgba(0,0,0,.2) !important;
            border-color: #5293bc !important;
        }

        &.selected {
            transform: scale(1) !important;
            box-shadow: 5px 20px 30px rgba(0,0,0,.2) !important;
            border-color: #5293bc !important;
        }

        .flex-center {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 10px;
            text-align: center;
        }

        .checkmark-checked {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background-color: #5293bc;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            align-items: center;
            justify-content: center;
            right: -22px;
            position: absolute;
            bottom: -11px;
        }

        p {
            font-weight: bold;
            font-size: 1.1rem;
            margin-bottom: 0px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/topbar/topbar.vue